
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.57 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M15.41 11.75l-4.63-7.91a1.28 1.28 0 00-.37-.4L5.61.21a1.23 1.23 0 00-1.29 0L.6 2.34A1.21 1.21 0 000 3.61l1.15 5.81a1.42 1.42 0 00.14.38l4.44 7.6a1.21 1.21 0 001.65.44L15 13.4a1.21 1.21 0 00.41-1.65zM3.2 4.25a1.15 1.15 0 111.58.42 1.16 1.16 0 01-1.58-.42z","data-name":"Layer 1"}})])])
          )
        }
      }
    